import { copySegments } from '../utils/rich-copy'

/** Walkthrough copy with "quoted" labels shown in bold, without the quotes. */
export function RichCopy({ text }: { text: string }) {
  return (
    <>
      {copySegments(text).map((seg, i) => (seg.bold ? <strong key={i}>{seg.text}</strong> : <span key={i}>{seg.text}</span>))}
    </>
  )
}
